import { mode_edit, mode_view } from '../../../../../../views/my-store/google-profile';

export default {
  title: 'Google-profiili',
  sections: {
    current_profile: {
      [mode_view]: 'Yhdistetty profiili',
      [mode_edit]: 'Vaihda yhdistettyä profiilia',
    },
  },
  form: {
    google_places_id: {
      label: 'Google Mapsin nimi',
    },
    address: {
      label: 'Osoite',
    },
    rating: {
      label: 'Arvio',
    },
    opening_hours: {
      label: 'Aukioloajat',
    },
    phone_number: {
      label: 'Puhelinnumero',
    },
    pictures: {
      label: 'Kuvat',
    },
  },
  labels: {
    no_place_connected: 'Tähän ravintolaan ei ole yhdistetty Google-profiilia',
    fields_to_sync: 'Tiedot synkronoitavaksi lähteestä {{name}}',
  },
  buttons: {
    save: 'Tallenna',
    change: 'Muuta',
    cancel: 'Peruuta',
  },
  toasts: {
    failed_to_save_changes: 'Muutosten tallennus epäonnistui',
    changes_got_saved: 'Muutokset tallennettiin',
  },
};
